import React, { useState, useEffect } from 'react';
import ReferralHeader from './ReferralHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Card } from '@mui/material';
import Footer from 'src/components/Footer';
import { ReferralContent } from './ReferralContent';
import { useAuth } from 'src/hooks/useAuth';
import { useReferral } from 'src/hooks/useReferral';
import { ReferralCodeResponse } from './referral.interface';

const PAGE_SIZE = 30;

const ReferralIndex = () => {
  const { enhancedFetch } = useAuth();
  const { getReferralCodes, loading: apiLoading } = useReferral();

  const [loadingDiscountDetails, setLoadingDiscountDetails] = useState(false);
  const [statusOptions, setStatusOptions] = useState<string[]>([]);
  const [selectedSortStatus, setSelectedSortStatus] = useState<string>('');
  const [selectedFilterStatus, setSelectedFilterStatus] = useState<string>('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const [referralCodes, setReferralCodes] = useState<ReferralCodeResponse[]>()
  const [totalReferralCodes, setTotalReferralCodes] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const fetchReferrals = async () => {
    setLoading(true);
    try {
      const data = await getReferralCodes();

      if (data) {
          setReferralCodes(data.content);
          setTotalReferralCodes(data.totalElements);
      }
    } catch (error) {
      console.error('Error fetching discounts:', error);
    } finally {
      setLoading(false);
    }
  };



  // Fetch Discounts by Page
  useEffect(() => {
    fetchReferrals().then();
  }, [page, rowsPerPage]);

  // Refresh discounts when refresh state changes
  useEffect(() => {
    if (refresh) {
      fetchReferrals().then();
    }
  }, [refresh]);

  // Set up status options based on discount applies to values
  useEffect(() => {
    const uniqueStatuses = [
      'ALL_VENDORS_ALL_PRODUCTS',
      'ALL_VENDORS',
      'ALL_PRODUCTS',
      'SELECTED_VENDORS_AND_SELECTED_PRODUCTS'
    ];
    setStatusOptions(uniqueStatuses);
  }, []);




  return (
    <>
      <title>Discounts</title>
      <PageTitleWrapper>
        <ReferralHeader
          statusOptions={statusOptions}
          selectedSortStatus={selectedSortStatus}
          setSelectedSortStatus={setSelectedSortStatus}
          selectedFilterStatus={selectedFilterStatus}
          setSelectedFilterStatus={setSelectedFilterStatus}
        />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <ReferralContent
                referrals={referralCodes}
                onRefresh={() => {
                  setRefresh(!refresh);
                }}
                loading={loading || apiLoading}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default ReferralIndex;
